import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AspectRatio, ExpandMore } from '@mui/icons-material';
import Warning from '@mui/icons-material/Warning';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    AppBar,
    Button,
    Checkbox,
    CircularProgress,
    FormControlLabel,
    Paper,
    Radio,
    RadioGroup,
    Tab,
    Tabs,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { blue } from '@mui/material/colors';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

import ModalConfirmacao from '@/components/sessao/ModalConfirmacao';
import ModoParticipacaoAdvogado, { MODO_PARTICIPACAO_ADVOGADO } from '@/dominio/ModoParticipacaoAdvogado';

import '../../css/certidao.css';
import ErrorUtil from '@/util/ErrorUtil';

import BusinessError from '../../util/BusinessError';
import Configuracao from '../../util/Configuracao';
import NomeUtil from '../../util/NomeUtil';
import StringUtil from '../../util/StringUtil';
import ModoAssinatura from '../assinatura/ModoAssinatura';
import AutoCompleteRedator from '../AutocompleteRedator';
import ReactComponent from '../ReactComponent';
import CodDecisaoMovCNJ from '../sessao/CodDecisaoMovCNJ';
import ModalComposicao from '../sessao/ModalComposicao';
import PresidenteSignatario from '../sessao/PainelDecisao/components/PresidenteSignatario';
import ProcuradorCertidao from '../sessao/ProcuradorCertidao';
import TextFieldSecretaria from '../TextFieldSecretaria';
import AlertaInconsistenciaEmentaDecisao, { TIPO_TEXTO } from './AlertaInconsistenciaEmentaDecisao';
import AUTO_TEXTO_CERTIDAO from './AutoTextoCertidao';
import CamposAutoTexto from './CamposAutoTexto';
import Signatario from './Signatario';

const TAG_RESUMO = '##RESUMO';
const TAG_DECISAO = '##DECISAO';
const TAG_PARTES = '##PARTES';

class Certidao extends ReactComponent {
    refCampoIdentificacao = React.createRef();
    refCampoDecisao = React.createRef();
    refCampoPartes = React.createRef();

    activeElement;
    carregando = true;
    cabecalho = '';
    resumo = '';
    decisao = '';
    partes = '';
    rascunho = '';
    rodape = '';
    divResumoDecisao = '';
    divPartes = '';
    mostrarRascunho = false;
    mostrarAnotacoes = false;
    mostrarEmenta = false;
    mostrarDecisao = false;
    decisaoOriginal = this.registro.decisao;
    ementa = this.registro.ementa;
    conteudoTextArea = '';
    tabAtiva = 3;
    certidaoSemModelo = false;
    cpfSignatario = null;
    modalComposicaoOpen = false;
    composicaoCancelada = false;
    processandoAssinatura = false;
    modalChaveOtpOpen = false;
    abrirConfirmacaoRestaurarCertidao = false;
    modalConfirmacaoDesbloqueioOpen = false;
    observacaoDecisaoPendente = null;

    atualizarActiveElement = () => {
        this.activeElement = document.activeElement;
    };

    removerActiveElement = () => {
        this.activeElement = undefined;
    };

    handleChangeCertidao = () => {
        this.certidaoSemModelo = !this.certidaoSemModelo;
    };

    handleTab = (tab) => {
        this.conteudoTextArea = '';
        this.tabAtiva = tab;

        switch (tab) {
            case 0:
                this.toggleRascunho();
                break;
            case 1:
                this.toggleDecisao();
                break;
            case 2:
                this.toggleEmenta();
                break;
            case 3:
                this.toggleAnotacoes();
                break;
            default:
                break;
        }
    };

    toggleAnotacoes = () => {
        this.mostrarEmenta = false;
        this.mostrarRascunho = false;
        this.mostrarDecisao = false;
        this.mostrarAnotacoes = true;
        this.conteudoTextArea = this.registro.informacaoProcessoSalaSessao.complementoAnotacoes || '';
    };

    toggleRascunho = () => {
        runInAction(() => {
            this.mostrarEmenta = false;
            this.mostrarAnotacoes = false;
            this.mostrarDecisao = false;
            this.mostrarRascunho = true;
            this.conteudoTextArea = this.rascunhoCertidao;
        });
    };

    toggleEmenta = async () => {
        this.mostrarAnotacoes = false;
        this.mostrarRascunho = false;
        this.mostrarDecisao = false;
        this.mostrarEmenta = true;
        this.mostrarEmenta && (await this.carregarEmentaDecisao());
        runInAction(() => {
            this.conteudoTextArea = this.registro.ementa;
        });
    };

    toggleDecisao = async () => {
        this.mostrarAnotacoes = false;
        this.mostrarEmenta = false;
        this.mostrarRascunho = false;
        this.mostrarDecisao = true;
        this.mostrarDecisao && (await this.carregarEmentaDecisao());
        runInAction(() => {
            this.conteudoTextArea = this.registro.decisao;
        });
    };

    carregarCertidao = async () => {
        if (!this.registro) {
            return;
        }
        let certidaoJSON = await this.certidaoService.recuperarCamposCertidao(
            this.registro,
            this.sessao.orgaoJudicante.sigla,
            this.sessao.orgaoJudicante.descricao,
            this.sessao.tipoJulgamento
        );

        if (!certidaoJSON) {
            const cpfSignatario = this.dominioStore.temSignatariosCadastradosOjc(this.sessao.orgaoJudicante.sigla)
                ? this.dominioStore.signatarioCadastradoDefaultOjc(this.sessao.orgaoJudicante.sigla).cpf
                : this.usuarioStore.usuario.cpf;
            await this.salaSessaoStore.carregarRascunhoCertidao(this.registro);
            certidaoJSON = await this.criarCertidaoPadrao(
                this.sessao,
                this.registro,
                this.registro.rascunhoCertidao,
                null,
                cpfSignatario,
                null,
                this.certidaoSemModelo
            );

            if (certidaoJSON) {
                runInAction(() => (this.registro.certidaoGerada = true));
                this.mensagemStore.abrirMensagemSucesso('Certidão padrão criada com sucesso');
            }
        }
        if (certidaoJSON) {
            this.marcarCertidaoSemModelo(certidaoJSON);
            this.verificarAssinaturaCertidao(certidaoJSON);
            this.carregarCamposCertidao(certidaoJSON);
            runInAction(() => (this.registro.conteudoCertidao = certidaoJSON.conteudoCompleto));
        }
    };

    carregarEmentaDecisao = async () => {
        if (this.registro && (!this.registro.ementa || !this.registro.decisao)) {
            await this.salaSessaoStore.carregarEmentaDecisao(this.registro);
        }
    };

    carregarRascunhoCertidao = () => {
        if (this.registro) {
            return this.salaSessaoStore.carregarRascunhoCertidao(this.registro);
        }
    };

    carregarPartes = async () => {
        if (this.registro) {
            await this.salaSessaoStore.carregarDetalhesProcesso(this.registro);
        }
    };

    callbackAutoComplete = async (campo, option) => {
        const valor = option && option.valor;
        this.callbackAutoCompleteVotos(campo, valor);
        this.callbackAutoCompleteAdvogados(campo, valor);
        await this.callbackAutoCompleteMagistrados(campo, valor);
    };

    callbackAutoCompleteVotos = (campo, valor) => {
        switch (campo) {
            case AUTO_TEXTO_CERTIDAO.VOTO_VENCIDO.id:
                this.incluirComplementoConteudoMagistradoAoFinal(valor, AUTO_TEXTO_CERTIDAO.VOTO_VENCIDO.texto);
                break;
            case AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_VENCIDO.id:
                this.incluirComplementoConteudo(valor, AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_VENCIDO.texto);
                break;
            case AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_CONVERGENTE.id:
                this.incluirComplementoConteudo(valor, AUTO_TEXTO_CERTIDAO.JUNTADA_VOTO_CONVERGENTE.texto);
                break;
            default:
                break;
        }
    };

    callbackAutoCompleteAdvogados = (campo, valor) => {
        switch (campo) {
            case AUTO_TEXTO_CERTIDAO.REGISTRO_PRESENCA.id:
                this.incluirComplementoAdvogado(valor, AUTO_TEXTO_CERTIDAO.REGISTRO_PRESENCA.texto);
                break;
            case AUTO_TEXTO_CERTIDAO.SUSTENTACAO_ORAL.id:
                this.incluirComplementoAdvogado(valor, AUTO_TEXTO_CERTIDAO.SUSTENTACAO_ORAL.texto);
                break;
            case AUTO_TEXTO_CERTIDAO.JUNTADA_PROCURACAO.id:
                this.incluirComplementoJuntadaProcuracao(valor);
                break;
            default:
                break;
        }
    };

    incluirComplementoAdvogado = (adv, complemento) => {
        const nomeAdv = adv ? adv.nome : '';
        const advogado = Certidao.advogados(this.registro).find((a) => {
            return a.texto && nomeAdv && nomeAdv.toString().toLowerCase().trim().includes(a.texto.toLowerCase().trim());
        });

        if (advogado) {
            if (complemento === AUTO_TEXTO_CERTIDAO.REGISTRO_PRESENCA.texto) {
                if (advogado.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo) {
                    complemento = AUTO_TEXTO_CERTIDAO.REGISTRO_PRESENCA_TELEPRESENCIAL.texto;
                } else if (advogado.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo) {
                    complemento = AUTO_TEXTO_CERTIDAO.REGISTRO_PARTICIPACAO_VIRTUAL.texto;
                }
            }

            if (
                complemento === AUTO_TEXTO_CERTIDAO.SUSTENTACAO_ORAL.texto &&
                advogado.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo
            ) {
                complemento = AUTO_TEXTO_CERTIDAO.SUSTENTACAO_ORAL_TELEPRESENCIAL.texto;
            }

            this.incluirObservacaoDecisao(this.replaceHashTags(complemento, advogado));
        }
    };

    incluirComplementoConteudoMagistradoAoFinal = (magistrado, complemento) => {
        if (magistrado) {
            this.incluirObservacaoDecisao(
                complemento + this.gerarTratamento(magistrado) + ' ' + magistrado.nome.trim()
            );
        }
    };

    incluirComplementoConteudo = (magistrado, complemento) => {
        if (magistrado) {
            this.incluirObservacaoDecisao(
                this.gerarTratamento(magistrado) + ' ' + magistrado.nome.trim() + complemento
            );
        }
    };

    verificarAssinaturaCertidao = (certidaoJSON) => {
        this.registro.certidaoJulgamentoAssinada = certidaoJSON.assinada === true;
    };

    carregarCamposCertidao = (certidaoJSON) => {
        if (!certidaoJSON) {
            return;
        }

        const certidao = document.createElement('div');
        certidao.innerHTML = certidaoJSON.conteudoCompleto;

        this.cabecalho = certidao.firstElementChild.querySelector('#cabecalho').outerHTML;
        this.resumo = certidaoJSON.resumo || '';

        this.decisao = certidaoJSON.decisao || '';

        this.divResumoDecisao = this.certidaoSemModelo
            ? '<div id="resumo-e-decisao" style="text-align: justify;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span id="resumo"></span> <span id="decisao"></span></div>'
            : this.getConteudoDivResumoDecisao(certidao);
        this.partes = this.formatarQuebraLinhaPartes(certidaoJSON.partes || '');
        this.cpfSignatario = certidaoJSON.cpfSignatario;
        this.divPartes = certidao.firstElementChild
            .querySelector('#partes')
            .outerHTML.replace(this.partes, () => TAG_PARTES);
        this.rodape = certidao.firstElementChild.querySelector('#rodape').outerHTML;
    };

    desbloquearAssinatura = () => {
        this.registro.certidaoJulgamentoAssinada = false;
        this.modalConfirmacaoDesbloqueioOpen = false;
    };

    confirmarDesbloqueioModal = () => {
        if (this.observacaoDecisaoPendente) {
            this.aplicarObservacaoDecisao(this.observacaoDecisaoPendente);
            this.observacaoDecisaoPendente = null;
        }
        this.desbloquearAssinatura();
    };

    changeResumo = (value) => {
        this.resumo = StringUtil.tratarCaracteresNaoLatin1(value);
    };

    changeDecisao = (value) => {
        const textoTratado = StringUtil.tratarCaracteresNaoLatin1(value);
        this.decisao = textoTratado;
    };

    changePartes = (value) => {
        this.partes = this.formatarQuebraLinhaPartes(StringUtil.tratarCaracteresNaoLatin1(value));
    };

    callbackAlterarProcurador = async (procurador) => {
        if (!this.certidaoAssinada && this.certidaoAssinada) {
            return;
        }

        this.registro.procurador = procurador;

        if (this.registro.processo.origem === Configuracao.ORIGEM_SIJ) {
            await this.sessaoService.alterarProcurador(
                this.registro.sessaoId,
                this.registro.processo.numeroCompleto,
                procurador
            );
        }
        const certidaoJson = await this.criarCertidaoPadrao(
            this.sessao,
            this.registro,
            this.decisao,
            this.partes,
            this.cpfSignatario,
            procurador,
            this.certidaoSemModelo
        );

        if (certidaoJson) {
            this.carregarCamposCertidao(certidaoJson);
            this.desbloquearAssinatura();
            this.mensagemStore.abrirMensagemSucesso('Certidão atualizada com sucesso');
        }
    };

    handleCarregarCertidaoPadrao = async () => {
        await this.salaSessaoStore.carregarRascunhoCertidao(this.registro);
        const certidaoJson = await this.criarCertidaoPadrao(
            this.sessao,
            this.registro,
            this.registro.rascunhoCertidao,
            null,
            this.cpfSignatario,
            null,
            this.certidaoSemModelo
        );

        if (certidaoJson) {
            this.carregarCamposCertidao(certidaoJson);
            this.desbloquearAssinatura();
            this.mensagemStore.abrirMensagemSucesso('Certidão padrão criada com sucesso');
        }
        this.abrirConfirmacaoRestaurarCertidao = false;
    };

    handleConfirmarRestaurarCertidao = () => {
        this.abrirConfirmacaoRestaurarCertidao = true;
    };

    fecharConfirmacaoRestaurarCertidao = () => {
        this.abrirConfirmacaoRestaurarCertidao = false;
    };

    handleAssinar = async () => {
        if (
            this.registro.processo.origem === Configuracao.ORIGEM_PJE &&
            this.sessaoStore.modoAssinatura === Configuracao.MODO_ASSINATURA_JTE
        ) {
            this.modalChaveOtpOpen = true;
        } else {
            await this.assinarSemOtp();
        }
    };

    callbackCancelar = () => {
        this.modalChaveOtpOpen = false;
        this.modalConfirmacaoDesbloqueioOpen = false;
        this.observacaoDecisaoPendente = null;
    };

    callbackContinuarAssinaturaOtp = async (chaveOtp) => {
        this.modalChaveOtpOpen = false;

        if (chaveOtp && chaveOtp.length === 6) {
            await this.assinarCertidoesOtp(chaveOtp);
        } else {
            this.mensagemStore.abrirMensagemAlerta('Código de autorização JTe inválido');
        }
    };

    confirmaDesbloqueio = () => {
        return (this.certidaoAssinada && this.AbrirModalDesbloqueio()) || !this.certidaoAssinada;
    };

    confirmarDesbloqueioComObservacaoPendente = () => {
        if (this.observacaoDecisaoPendente) {
            this.aplicarObservacaoDecisao(this.observacaoDecisaoPendente);
            this.observacaoDecisaoPendente = null;
        }
        this.desbloquearAssinatura();
    };

    handleCloseModalComposicao = () => {
        this.modalComposicaoOpen = false;
    };

    handleCancelarModalComposicao = () => {
        this.composicaoCancelada = true;
    };

    handleChangePainelInicioCertidao = (_event, expanded) => {
        this.salaSessaoStore.painelInicioCertidaoExpandido = expanded;
    };

    handleChangePainelDecisao = (_event, expanded) => {
        this.salaSessaoStore.painelDecisaoCertidaoExpandido = expanded;
    };

    handleChangePainelPartes = (_event, expanded) => {
        this.salaSessaoStore.painelPartesCertidaoExpandido = expanded;
    };

    handleExpandirInicioCertidao = (event) => {
        event.stopPropagation();
        this.salaSessaoStore.painelInicioCertidaoExpandido = true;
        this.salaSessaoStore.painelDecisaoCertidaoExpandido = false;
        this.salaSessaoStore.painelPartesCertidaoExpandido = false;
    };

    handleExpandirDecisao = (event) => {
        event.stopPropagation();
        this.salaSessaoStore.painelInicioCertidaoExpandido = false;
        this.salaSessaoStore.painelDecisaoCertidaoExpandido = true;
        this.salaSessaoStore.painelPartesCertidaoExpandido = false;
    };

    handleExpandirPartes = (event) => {
        event.stopPropagation();
        this.salaSessaoStore.painelInicioCertidaoExpandido = false;
        this.salaSessaoStore.painelDecisaoCertidaoExpandido = false;
        this.salaSessaoStore.painelPartesCertidaoExpandido = true;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            activeElement: observable,
            carregando: observable,
            cabecalho: observable,
            resumo: observable,
            decisao: observable,
            partes: observable,
            rascunho: observable,
            rodape: observable,
            divResumoDecisao: observable,
            divPartes: observable,
            mostrarRascunho: observable,
            mostrarAnotacoes: observable,
            mostrarEmenta: observable,
            mostrarDecisao: observable,
            decisaoOriginal: observable,
            ementa: observable,
            conteudoTextArea: observable,
            tabAtiva: observable,
            certidaoSemModelo: observable,
            cpfSignatario: observable,
            modalComposicaoOpen: observable,
            composicaoCancelada: observable,
            processandoAssinatura: observable,
            modalChaveOtpOpen: observable,
            abrirConfirmacaoRestaurarCertidao: observable,
            modalConfirmacaoDesbloqueioOpen: observable,
            observacaoDecisaoPendente: observable,
            labelTextArea: computed,
            mostrarTextArea: computed,
            visualizacaoResumo: computed,
            visualizacaoPartes: computed,
            rascunhoCertidao: computed,
            bloquearEdicaoCertidao: computed,
            bloquearRestaurarCertidao: computed,
            tipoJulgamento: computed,
            sessao: computed,
            assinaturaHabilitada: computed,
            alturaCamposCertidao: computed,
            alturaUtilCamposCertidao: computed,
            qtdPaineisExpandidos: computed,
            camposAutoTextoDecisaoExpandidos: computed,
            magistrados: computed,
            destacarCampoIdentificacao: computed,
            destacarCampoDecisao: computed,
            destacarCampoPartes: computed,
            existePresidenteComposicao: computed,
            desabilitarMovimentosNaoTransferidos: computed,
            renderConteudoCertidao: computed,
            renderPainelEsquerdo: computed,
            renderCamposCertidao: computed,
            renderPainelTiposJulgamento: computed,
            renderFerramentasCertidao: computed,
            renderAlertaInconsistenciaEmentaDecisao: computed,
            renderRascunhoEmentaDecisaoAnotacoes: computed,
            certidaoAssinada: computed,
            atualizarActiveElement: action,
            removerActiveElement: action,
            handleChangeCertidao: action,
            handleTab: action,
            toggleAnotacoes: action,
            toggleRascunho: action,
            toggleEmenta: action,
            toggleDecisao: action,
            carregarCertidao: action,
            callbackAutoComplete: action,
            callbackAutoCompleteVotos: action,
            incluirObservacaoDecisao: action,
            callbackAutoCompleteAdvogados: action,
            marcarCertidaoSemModelo: action,
            verificarAssinaturaCertidao: action,
            carregarCamposCertidao: action,
            desbloquearAssinatura: action,
            changeResumo: action,
            changeDecisao: action,
            changePartes: action,
            callbackAlterarProcurador: action,
            callbackAlterarCpfSignatario: action,
            aplicarObservacaoDecisao: action,
            confirmarDesbloqueioComObservacaoPendente: action,
            handleCarregarCertidaoPadrao: action,
            handleConfirmarRestaurarCertidao: action,
            fecharConfirmacaoRestaurarCertidao: action,
            handleAssinar: action,
            callbackCancelar: action,
            callbackContinuarAssinaturaOtp: action,
            AbrirModalDesbloqueio: action,
            handleCloseModalComposicao: action,
            handleCancelarModalComposicao: action,
            handleChangePainelInicioCertidao: action,
            handleChangePainelDecisao: action,
            handleChangePainelPartes: action,
            handleExpandirInicioCertidao: action,
            handleExpandirDecisao: action,
            handleExpandirPartes: action,
            refCampoIdentificacao: false,
            refCampoDecisao: false,
            refCampoPartes: false,
            componentDidMount: false,
            montaResumo: false,
            getConteudoPosDecisao: false,
            getConteudoPosResumo: false,
            getConteudoPreResumo: false,
            gerarTratamento: false,
            carregarEmentaDecisao: false,
            carregarRascunhoCertidao: false,
            carregarPartes: false,
            incluirComplementoConteudoMagistradoAoFinal: false,
            incluirComplementoConteudo: false,
            incluirComplementoJuntadaProcuracao: false,
            incluirComplementoAdvogado: false,
            replaceHashTags: false,
            callbackAutoCompleteMagistrados: false,
            criarCertidaoPadrao: false,
            getConteudoDivResumoDecisao: false,
            formatarQuebraLinhaPartes: false,
            assinarCertidoesOtp: false,
            confirmaDesbloqueio: false,
            renderModalConfirmaDesbloqueio: false,
            assinarSemOtp: false,
            botaoAssinarDesabilitado: false,
            getTooltipBotaoAssinar: false,
            getTooltipBotaoRestaurarCertidao: false,
            getRotuloBotaoAssinar: false,
            isOrigemPJe: false,
            render: false,
            accordionSummaryStyle: false,
            getExpandIcon: false,
            renderConfirmacao: false,
            estiloAbas: false,
            getQuantidadeObservacoes: false,
            adicionarObservacao: false,
            confirmarDesbloqueioModal: false,
            registro: false
        });

        this.createReaction(
            reaction(
                () => this.registro?.numeroProcesso,
                () => {
                    if (!this.observableProps.aberto) {
                        return;
                    }

                    this.carregando = true;
                    this.componentDidMount();
                }
            )
        );
        this.createReaction(
            reaction(
                () => this.registro?.ementa,
                (ementa) => {
                    this.ementa = ementa;
                }
            )
        );
        this.createReaction(
            reaction(
                () => this.registro?.decisao,
                (decisao) => {
                    this.decisaoOriginal = decisao;
                }
            )
        );
        this.createReaction(
            reaction(
                () => this.modalComposicaoOpen,
                () => {
                    if (this.modalComposicaoOpen) {
                        this.composicaoCancelada = false;
                    } else if (!this.composicaoCancelada) {
                        this.componentDidMount();
                    }
                }
            )
        );
    }

    static advogados(registro) {
        const advogados = [];

        if (registro?.pedidoSustentacaoOral?.pedidosDetalhados) {
            registro.pedidoSustentacaoOral.pedidosDetalhados.map((pedido) => {
                pedido.advogados.map((adv) => {
                    const isSegredoJustica = registro.segredoJustica
                        ? NomeUtil.abreviarNome(pedido.nomeDaParte)
                        : pedido.nomeDaParte;

                    advogados.push({
                        valor: adv,
                        texto: adv.nome,
                        textoSecundario: `Modo de participação: ${ModoParticipacaoAdvogado.getDescricaoByCodigo(adv.modoParticipacao)} | Parte: ${pedido.nomeDaParte}`,
                        genero: adv.genero,
                        nome: adv.nome,
                        modoParticipacao: adv.modoParticipacao,
                        denominacaoDaParte: pedido.denominacaoDaParte,
                        nomeDaParte: pedido.nomeDaParte ? isSegredoJustica : ''
                    });

                    return adv;
                });

                return pedido;
            });
        }

        return advogados;
    }

    async componentDidMount() {
        try {
            await this.carregarPartes();
            await this.carregarRascunhoCertidao();
            await this.toggleAnotacoes();
            await this.carregarCertidao();
            runInAction(() => {
                this.carregando = false;
                this.handleTab(this.tabAtiva);
                this.salaSessaoStore.painelInicioCertidaoExpandido = true;
                this.salaSessaoStore.painelDecisaoCertidaoExpandido = true;
                this.salaSessaoStore.painelPartesCertidaoExpandido = true;
            });
        } catch (error) {
            console.error(`Falha na inicialização do componente Certidao: ${ErrorUtil.getMensagemErro(error)}`);
            throw new Error('Falha na inicialização do componente Certidao', { cause: error });
        }
    }

    get labelTextArea() {
        if (this.mostrarRascunho) {
            return 'Rascunho da certidão';
        }

        if (this.mostrarDecisao) {
            return 'Decisão original';
        }

        if (this.mostrarEmenta) {
            return 'Ementa';
        }

        return 'Anotações';
    }

    get mostrarTextArea() {
        return this.mostrarRascunho || this.mostrarDecisao || this.mostrarEmenta || this.mostrarAnotacoes;
    }

    get visualizacaoResumo() {
        if (this.divResumoDecisao.length > 0) {
            const div = document.createElement('div');
            div.innerHTML = this.divResumoDecisao;
            const campoResumo = div.querySelector('#resumo');
            const campoDecisao = div.querySelector('#decisao');

            if (campoResumo && campoDecisao) {
                return this.montaResumo(campoResumo, campoDecisao, div);
            }
        }
        return '';
    }

    montaResumo(campoResumo, campoDecisao, div) {
        campoResumo.innerHTML = (this.resumo || '').replaceAll('\n', '<br/>');
        campoResumo.style.opacity = !this.activeElement || this.destacarCampoIdentificacao ? 1 : 0.5;
        campoResumo.style.fontSize = this.destacarCampoIdentificacao ? 'large' : 'medium';

        campoDecisao.innerHTML = (this.decisao || '').replaceAll('\n', '<br/>');
        campoDecisao.style.opacity = !this.activeElement || this.destacarCampoDecisao ? 1 : 0.5;
        campoDecisao.style.fontSize = this.destacarCampoDecisao ? 'large' : 'medium';

        return (
            this.getConteudoPreResumo(div, campoResumo) +
            campoResumo.outerHTML +
            this.getConteudoPosResumo(div, campoResumo, campoDecisao) +
            campoDecisao.outerHTML +
            this.getConteudoPosDecisao(div, campoDecisao)
        );
    }

    getConteudoPosDecisao(div, campoDecisao) {
        const spanPosDecisao = document.createElement('span');
        spanPosDecisao.style.opacity = this.activeElement ? 0.5 : 1;
        spanPosDecisao.innerHTML = div
            .getHTML()
            .slice(Math.max(0, div.getHTML().indexOf(campoDecisao.outerHTML) + campoDecisao.outerHTML.length));
        return spanPosDecisao.outerHTML;
    }

    getConteudoPosResumo(div, campoResumo, campoDecisao) {
        const spanPosResumo = document.createElement('span');
        spanPosResumo.style.opacity = this.activeElement ? 0.5 : 1;
        spanPosResumo.innerHTML = div
            .getHTML()
            .slice(
                div.getHTML().indexOf(campoResumo.outerHTML) + campoResumo.outerHTML.length,
                div.getHTML().indexOf(campoDecisao.outerHTML)
            );
        return spanPosResumo.outerHTML;
    }

    getConteudoPreResumo(div, campoResumo) {
        const spanPreResumo = document.createElement('span');
        spanPreResumo.style.opacity = this.activeElement ? 0.5 : 1;
        spanPreResumo.innerHTML = div.getHTML().slice(0, Math.max(0, div.getHTML().indexOf(campoResumo.outerHTML)));
        return spanPreResumo.outerHTML;
    }

    get visualizacaoPartes() {
        if (this.divPartes.length > 0) {
            const div = document.createElement('div');
            div.innerHTML = this.divPartes;

            if ((this.partes || this.partes === '') && div.querySelector('#partes')) {
                div.querySelector('#partes').innerHTML = this.partes.replaceAll('\n', '<br/>');
            }
            return div.outerHTML;
        }
        return '';
    }

    get rascunhoCertidao() {
        return this.registro.rascunhoCertidao ? this.registro.rascunhoCertidao.toString() : '';
    }

    gerarTratamento(magistrado) {
        return this.salaSessaoStore.pronomeTratamentoComCargo(magistrado);
    }

    get bloquearEdicaoCertidao() {
        return (
            this.registro.certidaoJulgamentoTransferida &&
            !this.registro.informacoesAdicionais.permitirQuebraAssinaturaCertidao
        );
    }

    get bloquearRestaurarCertidao() {
        return !this.existePresidenteComposicao || this.bloquearEdicaoCertidao;
    }

    get registro() {
        return this.observableProps.registro;
    }

    get tipoJulgamento() {
        return this.registro.tipoJulgamento;
    }

    get sessao() {
        return this.sessaoStore.sessaoSelecionada;
    }

    get certidaoAssinada() {
        return !!this.registro?.certidaoJulgamentoAssinada;
    }

    adicionarObservacao(textoBase, conteudo) {
        const texto = textoBase || '';

        if (texto.includes(conteudo)) {
            return texto;
        }
        const textoRenumerado = this.salaSessaoStore.renumerarObservacoes(texto);
        const numeroObservacao = this.salaSessaoStore.getQuantidadeObservacoes(texto) + 1;
        return textoRenumerado + '\nObservação ' + numeroObservacao + ': ' + conteudo + '.\n';
    }

    incluirObservacaoDecisao(conteudo) {
        if (this.decisao && this.decisao.includes(conteudo)) {
            this.mensagemStore.abrirMensagemAlerta('Observação já presente no texto.');
            return;
        }

        if (this.certidaoAssinada) {
            this.observacaoDecisaoPendente = conteudo;
            this.AbrirModalDesbloqueio();
            return;
        }

        this.aplicarObservacaoDecisao(conteudo);
    }

    aplicarObservacaoDecisao(conteudo) {
        const novaDecisao = this.adicionarObservacao(this.decisao, conteudo);

        if (novaDecisao !== this.decisao) {
            this.decisao = novaDecisao;
            this.certidaoService.salvarDecisao(this.registro, this.decisao);
        }
    }

    getQuantidadeObservacoes() {
        return this.salaSessaoStore.getQuantidadeObservacoes(this.decisao);
    }

    incluirComplementoJuntadaProcuracao(valor) {
        this.incluirComplementoAdvogado(
            valor,
            this.salaSessaoStore.isProcessoPje(this.registro)
                ? AUTO_TEXTO_CERTIDAO.JUNTADA_PROCURACAO_PJE.texto
                : AUTO_TEXTO_CERTIDAO.JUNTADA_PROCURACAO.texto
        );
    }

    replaceHashTags(texto, advogado) {
        const turma = this.usuarioStore.usuario.descricaoLocalizacao;
        return texto
            .replaceAll('#ADV_GEN2', () => (advogado.genero === 'F' ? 'a' : 'o'))
            .replaceAll('#ADV_CAP_GEN2', () => (advogado.genero === 'F' ? 'a' : 'o'))
            .replaceAll('#ADV_GEN', () => (advogado.genero === 'F' ? 'a' : ''))
            .replaceAll('#NOME_ADV', () => (advogado.nome ? advogado.nome.trim() : ''))
            .replaceAll('#DENOMINACAO_PARTE', () => advogado.denominacaoDaParte)
            .replaceAll('#NOME_PARTE', () => (advogado.nomeDaParte ? advogado.nomeDaParte.trim() : ''))
            .replaceAll('#TURMA', () => turma);
    }

    callbackAutoCompleteMagistrados(campo, valor) {
        switch (campo) {
            case AUTO_TEXTO_CERTIDAO.RESSALVA_ENTENDIMENTO.id:
                this.incluirComplementoConteudo(valor, AUTO_TEXTO_CERTIDAO.RESSALVA_ENTENDIMENTO.texto);
                break;
            case AUTO_TEXTO_CERTIDAO.RESSALVA_FUNDAMENTACAO.id:
                this.incluirComplementoConteudo(valor, AUTO_TEXTO_CERTIDAO.RESSALVA_FUNDAMENTACAO.texto);
                break;
            case AUTO_TEXTO_CERTIDAO.REGISTRO_IMPEDIMENTO.id:
                this.incluirComplementoConteudoMagistradoAoFinal(valor, AUTO_TEXTO_CERTIDAO.REGISTRO_IMPEDIMENTO.texto);
                break;
            case AUTO_TEXTO_CERTIDAO.REGISTRO_AUSENCIA.id:
                this.incluirComplementoConteudoMagistradoAoFinal(valor, AUTO_TEXTO_CERTIDAO.REGISTRO_AUSENCIA.texto);
                break;
            default:
                break;
        }
    }

    async criarCertidaoPadrao(
        sessao,
        registro,
        textoDecisao,
        textoPartes,
        cpfSignatario,
        procurador,
        certidaoSemModelo
    ) {
        let retorno;

        try {
            if (!textoDecisao) {
                if (!this.registro.decisao) {
                    await this.carregarEmentaDecisao();
                }
                textoDecisao = this.registro.decisao;
            }
            retorno = await this.certidaoService.criarCertidaoPadrao(
                sessao,
                registro,
                textoDecisao,
                textoPartes,
                cpfSignatario,
                procurador,
                certidaoSemModelo
            );

            if (retorno) {
                runInAction(() => (this.registro.conteudoCertidao = retorno.conteudoCompleto));
            }
        } catch (error) {
            if (error instanceof BusinessError) {
                this.mensagemStore.abrirMensagemErro(error.message);
                runInAction(() => (this.modalComposicaoOpen = true));
            } else {
                throw error;
            }
        }
        return retorno;
    }

    marcarCertidaoSemModelo(certidaoJSON) {
        if (certidaoJSON?.modelo?.modeloSemDecisao) {
            this.certidaoSemModelo = true;
        }
    }

    getConteudoDivResumoDecisao(certidao) {
        let resumoDecisao = certidao.firstElementChild.querySelector('#resumo-e-decisao').getHTML();

        if (this.resumo && this.resumo !== '') {
            resumoDecisao = resumoDecisao.replace(this.resumo, () => TAG_RESUMO);
        }
        if (this.decisao && this.decisao !== '') {
            resumoDecisao = resumoDecisao.replace(this.decisao, () => TAG_DECISAO);
        }
        return resumoDecisao;
    }

    formatarQuebraLinhaPartes(partes) {
        // (sem flag /g, remove só a primeira ocorrência que casar) para não alterar o comportamento existente.
        // eslint-disable-next-line sonarjs/super-linear-regex
        return '\n' + partes.replace(/^\n+|\n+$/, '') + '\n\n';
    }

    async callbackAlterarCpfSignatario(cpfSignatario) {
        if (!this.certidaoAssinada && this.certidaoAssinada) {
            return;
        }

        await this.certidaoService.salvarCpfSignatario(this.registro, cpfSignatario);
        const certidaoJson = await this.criarCertidaoPadrao(
            this.sessao,
            this.registro,
            this.decisao,
            this.partes,
            cpfSignatario,
            null,
            this.certidaoSemModelo
        );

        if (certidaoJson) {
            this.carregarCamposCertidao(certidaoJson);
            this.desbloquearAssinatura();
            this.mensagemStore.abrirMensagemSucesso('Certidão atualizada com sucesso');
        }
    }

    async assinarCertidoesOtp(chaveOtp) {
        try {
            this.processandoAssinatura = true;
            const resultadoProcessamento = await this.assinaturaService.assinarCertidoesOtp(
                [
                    {
                        numeroProcesso: this.registro.processo.numeroCompleto,
                        sessaoId: this.registro.sessaoId,
                        tipoJulgamento: this.registro.tiopoJulgamento
                    }
                ],
                this.sessao.id,
                this.sessao.tipoJulgamento,
                this.sessao.orgaoJudicante,
                chaveOtp
            );

            if (this.salaSessaoStore.isResultadoSucesso(resultadoProcessamento)) {
                runInAction(() => {
                    this.registro.certidaoJulgamentoAssinada = true;

                    if (this.registro.processo.origem === Configuracao.ORIGEM_PJE) {
                        this.registro.certidaoJulgamentoTransferida = true;
                        this.registro.informacoesAdicionais.permitirQuebraAssinaturaCertidao = true;
                    }
                });

                this.mensagemStore.abrirMensagemSucesso('Certidão assinada com sucesso.');
            } else {
                this.mensagemStore.abrirMensagemErro(
                    'Erro ao assinar a certidão: ' + resultadoProcessamento[0].mensagem
                );
            }
        } catch (error) {
            this.errorStore.tratarRespostaErro(error);
        } finally {
            runInAction(() => (this.processandoAssinatura = false));
        }
    }

    AbrirModalDesbloqueio() {
        this.modalConfirmacaoDesbloqueioOpen = true;
    }

    renderModalConfirmaDesbloqueio() {
        return this.certidaoAssinada ? (
            <ModalConfirmacao
                callbackCancelar={this.callbackCancelar}
                callbackConfirmar={this.confirmarDesbloqueioComObservacaoPendente}
                open={this.modalConfirmacaoDesbloqueioOpen}
                titulo={'Desbloquear assinatura?'}
            >
                <Typography style={{ color: 'red' }}>
                    Esta alteração vai remover a assinatura da certidão. Confirma?
                </Typography>{' '}
            </ModalConfirmacao>
        ) : null;
    }

    async assinarSemOtp() {
        try {
            this.processandoAssinatura = true;
            const processoAssinatura = {
                numeroProcesso: this.registro.processo.numeroCompleto,
                tipoJulgamento: this.registro.tipoJulgamento
            };

            const resultadoProcessamento = this.salaSessaoStore.isSessaoSIJ(this.registro.sessaoId)
                ? await this.assinaturaService.assinarSIJ(
                      [processoAssinatura],
                      this.registro.sessaoId,
                      this.sessao.orgaoJudicante,
                      this.sessao.tipoJulgamento
                  )
                : await this.assinaturaService.assinarPje(
                      [processoAssinatura],
                      this.registro.sessaoId,
                      this.sessao.orgaoJudicante,
                      this.sessao.tipoJulgamento
                  );

            if (this.salaSessaoStore.isResultadoSucesso(resultadoProcessamento)) {
                runInAction(() => {
                    this.registro.certidaoJulgamentoAssinada = true;
                });

                this.mensagemStore.abrirMensagemSucesso('Certidão assinada com sucesso.');
            } else {
                const mensagem = resultadoProcessamento?.[0]?.mensagem ?? 'Ocorreu um erro inesperado.';
                this.mensagemStore.abrirMensagemErro(mensagem);
            }
        } catch (error) {
            if (error instanceof BusinessError) {
                this.mensagemStore.abrirMensagemAlerta(error.message);
            } else {
                if (error instanceof Error) {
                    this.mensagemStore.abrirMensagemErro(error.message);
                } else {
                    this.mensagemStore.abrirMensagemErro(String(error));
                }
            }
        } finally {
            runInAction(() => (this.processandoAssinatura = false));
        }
    }

    get assinaturaHabilitada() {
        return !this.certidaoAssinada;
    }

    get alturaCamposCertidao() {
        return this.alturaUtilCamposCertidao / (this.qtdPaineisExpandidos || 1) - 30;
    }

    get alturaUtilCamposCertidao() {
        return this.appStore.alturaJanela - 470;
    }

    get qtdPaineisExpandidos() {
        return (
            (this.salaSessaoStore.painelInicioCertidaoExpandido ? 1 : 0) +
            (this.salaSessaoStore.painelDecisaoCertidaoExpandido ? 1 : 0) +
            (this.salaSessaoStore.painelPartesCertidaoExpandido ? 1 : 0)
        );
    }

    botaoAssinarDesabilitado() {
        return (
            this.processandoAssinatura ||
            !this.assinaturaHabilitada ||
            this.bloquearEdicaoCertidao ||
            this.desabilitarMovimentosNaoTransferidos
        );
    }

    get desabilitarMovimentosNaoTransferidos() {
        return (
            this.isComponenteHabilitado('ModoAssinatura') &&
            this.sessaoStore.modoAssinatura === Configuracao.MODO_ASSINATURA_JTE &&
            this.registro.processo.origem === Configuracao.ORIGEM_PJE &&
            !this.registro.movimentosTransferidos
        );
    }

    getTooltipBotaoAssinar() {
        if (this.processandoAssinatura) {
            return 'Processando assinatura da certidão...</Typography>';
        }

        if (this.bloquearEdicaoCertidao) {
            return `Certidão já enviada para o ${this.registro.processo.origem}`;
        }

        if (this.certidaoAssinada) {
            return 'Certidão já assinada. Efetue alterações para desbloquear.';
        }

        if (this.desabilitarMovimentosNaoTransferidos) {
            return 'Para assinar com JTe, os movimentos devem ser enviados ao PJe antes que a certidão seja assinada e enviada';
        }

        return 'Assinar Certidão';
    }

    getTooltipBotaoRestaurarCertidao() {
        if (this.bloquearEdicaoCertidao) {
            return `Certidão já enviada para o ${this.registro.processo.origem}`;
        }

        if (this.existePresidenteComposicao) {
            return 'Desfazer todas as alterações e gerar a certidão padrão';
        }

        return 'Defina o presidente da composição para restaurar a certidão padrão';
    }

    getRotuloBotaoAssinar() {
        if (this.certidaoAssinada) {
            return 'Assinada';
        }
        return this.isOrigemPJe() && this.sessaoStore.modoAssinatura === Configuracao.MODO_ASSINATURA_JTE
            ? 'Assinar e enviar'
            : 'Assinar';
    }

    isOrigemPJe() {
        return this.registro.processo.origem === Configuracao.ORIGEM_PJE;
    }

    get camposAutoTextoDecisaoExpandidos() {
        return (
            this.salaSessaoStore.painelDecisaoCertidaoExpandido &&
            !this.salaSessaoStore.painelInicioCertidaoExpandido &&
            !this.salaSessaoStore.painelPartesCertidaoExpandido
        );
    }

    get magistrados() {
        if (this.registro.processo.origem === Configuracao.ORIGEM_PJE) {
            return this.dominioStore.opcoesMagistradosComposicao(this.registro);
        }
        return this.dominioStore.opcoesMagistradosAutoComplete(this.registro);
    }

    get destacarCampoIdentificacao() {
        return this.activeElement === this.refCampoIdentificacao.current;
    }

    get destacarCampoDecisao() {
        return this.activeElement === this.refCampoDecisao.current;
    }

    get destacarCampoPartes() {
        return this.activeElement === this.refCampoPartes.current;
    }

    get existePresidenteComposicao() {
        return (
            this.registro &&
            this.registro.composicao.some((composicao) => composicao.magistrado.presidenteSessao === true)
        );
    }

    render() {
        return this.carregando ? (
            <div style={{ margin: '20px' }}>
                <CircularProgress />
            </div>
        ) : (
            <div
                style={{
                    display: 'flex',
                    flexGrow: 1,
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    margin: '5px',
                    overflow: 'hidden'
                }}
            >
                {this.renderPainelEsquerdo}
                {this.renderConteudoCertidao}
                {this.modalComposicaoOpen ? (
                    <ModalComposicao
                        onCancel={this.handleCancelarModalComposicao}
                        onClose={this.handleCloseModalComposicao}
                        open={true}
                        registro={this.registro}
                    />
                ) : null}
            </div>
        );
    }

    get renderConteudoCertidao() {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '43%' }}>
                <Paper
                    style={{
                        display: 'flex',
                        maxWidth: '800px',
                        margin: '0px 10px 10px 20px',
                        flexGrow: '1',
                        overflowY: 'auto'
                    }}
                    elevation={10}
                >
                    <div
                        style={{
                            display: 'flex',
                            width: '100%',
                            flexDirection: 'column',
                            padding: '10px',
                            textAlign: 'justify',
                            maxHeight: '40px'
                        }}
                    >
                        {}
                        <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: this.cabecalho }}
                            style={{ opacity: this.activeElement === undefined ? 1 : 0.5 }}
                        />
                        <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: this.visualizacaoResumo }}
                        />
                        {}
                        <div
                            style={{
                                opacity: !this.activeElement || this.destacarCampoPartes ? 1 : 0.5,
                                fontSize: this.destacarCampoPartes ? 'large' : 'medium'
                            }}
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: this.visualizacaoPartes }}
                        />
                        {}
                        <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: this.rodape }}
                            style={{ opacity: this.activeElement === undefined ? 1 : 0.5, paddingBottom: '24px' }}
                        />
                    </div>
                </Paper>
                <div style={{ margin: '8px 16px' }}>
                    {this.bloquearEdicaoCertidao || (
                        <Signatario
                            assinada={this.certidaoAssinada}
                            callbackAlterarCpfSignatario={this.callbackAlterarCpfSignatario.bind(this)}
                            cpfSignatario={this.cpfSignatario}
                        />
                    )}
                </div>
            </div>
        );
    }

    get renderPainelEsquerdo() {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, width: '57%' }}>
                {this.renderCamposCertidao}
                <div style={{ zIndex: 9, backgroundColor: 'white', marginTop: '2px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                        <div style={{ display: 'flex', width: '100%', marginTop: '5px' }}>
                            <CodDecisaoMovCNJ
                                id="certidao"
                                registro={this.registro}
                            />
                            {this.renderPainelTiposJulgamento}
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                width: '98%',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexDirection: 'column'
                            }}
                        >
                            {this.renderFerramentasCertidao}
                        </div>
                    </div>
                    {this.renderRascunhoEmentaDecisaoAnotacoes}
                </div>
            </div>
        );
    }

    get renderCamposCertidao() {
        const calculaAlturaCamposCertidao = this.camposAutoTextoDecisaoExpandidos
            ? this.alturaCamposCertidao - 140
            : this.alturaCamposCertidao;
        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: this.alturaUtilCamposCertidao + 73 }}>
                {this.renderModalConfirmaDesbloqueio()}
                <Accordion
                    expanded={this.salaSessaoStore.painelInicioCertidaoExpandido}
                    onChange={this.handleChangePainelInicioCertidao}
                    style={{ margin: '0px' }}
                    sx={{ expanded: { height: '100%' } }}
                >
                    <AccordionSummary
                        expandIcon={this.getExpandIcon()}
                        style={{ minHeight: '24px' }}
                        sx={this.accordionSummaryStyle}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexGrow: 1
                            }}
                        >
                            <Typography
                                color="primary"
                                style={{ fontSize: '0.9rem', fontWeight: 'bold' }}
                                variant="subtitle2"
                            >
                                Identificação e composição
                            </Typography>
                            <Tooltip
                                placement="top"
                                title={'Expandir Identificação e composição'}
                            >
                                <AspectRatio
                                    style={{
                                        marginRight: '8px',
                                        cursor: 'pointer',
                                        width: '20px',
                                        height: '20px',
                                        color: blue[900],
                                        fillOpacity: '0.7'
                                    }}
                                    onClick={this.handleExpandirInicioCertidao}
                                />
                            </Tooltip>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails style={{ display: 'flex', flexGrow: 1, padding: '4px' }}>
                        <TextFieldSecretaria
                            inputProps={{
                                disabled: this.bloquearEdicaoCertidao,
                                style: {
                                    height: this.salaSessaoStore.painelInicioCertidaoExpandido
                                        ? this.alturaCamposCertidao
                                        : '0px'
                                }
                            }}
                            bloqueio={this.confirmaDesbloqueio}
                            callbackDesbloqueio={this.desbloquearAssinatura}
                            disabled={this.bloquearEdicaoCertidao ? true : false}
                            inputRef={this.refCampoIdentificacao}
                            margin="none"
                            multiline={true}
                            onChange={this.changeResumo}
                            onFocus={this.atualizarActiveElement}
                            onLoseFocus={this.removerActiveElement}
                            salvar={this.certidaoService.salvarResumo.bind(this, this.registro)}
                            spellCheck={true}
                            style={{ width: '100%' }}
                            tempoTimeout={4000}
                            usarBloqueio={true}
                            value={this.resumo.trim()}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={this.salaSessaoStore.painelDecisaoCertidaoExpandido}
                    onChange={this.handleChangePainelDecisao}
                    style={{ margin: '0px' }}
                    sx={{ expanded: { height: '100%' } }}
                >
                    <AccordionSummary
                        expandIcon={this.getExpandIcon()}
                        style={{ minHeight: '24px' }}
                        sx={this.accordionSummaryStyle}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexGrow: 1
                            }}
                        >
                            <Typography
                                color="primary"
                                style={{ fontSize: '0.9rem', fontWeight: 'bold' }}
                                variant="subtitle2"
                            >
                                Decisão
                            </Typography>
                            <Tooltip
                                placement="top"
                                title={'Expandir Decisão/Campos de AutoTexto'}
                            >
                                <AspectRatio
                                    style={{
                                        marginRight: '8px',
                                        cursor: 'pointer',
                                        width: '20px',
                                        height: '20px',
                                        color: blue[900],
                                        fillOpacity: '0.7'
                                    }}
                                    onClick={this.handleExpandirDecisao}
                                />
                            </Tooltip>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails style={{ display: 'flex', flexGrow: 1, padding: '4px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            {this.camposAutoTextoDecisaoExpandidos ? (
                                <div style={{ marginBottom: '4px' }}>
                                    <CamposAutoTexto
                                        advogados={Certidao.advogados(this.registro)}
                                        callbackAutoComplete={this.callbackAutoComplete}
                                        id={'certidao'}
                                        magistrados={this.magistrados}
                                        registro={this.registro}
                                    />
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            width: '100%',
                                            margin: '10px 0px',
                                            gap: '16px'
                                        }}
                                    >
                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                                            <PresidenteSignatario
                                                onChangeTexto={action((novoTexto) => {
                                                    this.decisao = novoTexto;
                                                })}
                                                callbackDesbloqueio={this.desbloquearAssinatura}
                                                registro={this.registro}
                                                textoAtual={this.decisao}
                                            />
                                        </div>

                                        <div style={{ flex: 1 }}>
                                            <AutoCompleteRedator
                                                onChangeTexto={action((novoTexto) => {
                                                    this.decisao = novoTexto;
                                                })}
                                                callbackDesbloqueio={this.desbloquearAssinatura}
                                                registro={this.registro}
                                                textoAtual={this.decisao}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            <TextFieldSecretaria
                                inputProps={{
                                    disabled: this.bloquearEdicaoCertidao,
                                    style: {
                                        height: this.salaSessaoStore.painelDecisaoCertidaoExpandido
                                            ? calculaAlturaCamposCertidao
                                            : '0px'
                                    }
                                }}
                                bloqueio={this.confirmaDesbloqueio}
                                callbackDesbloqueio={this.desbloquearAssinatura}
                                disabled={this.bloquearEdicaoCertidao ? true : false}
                                inputRef={this.refCampoDecisao}
                                margin="none"
                                onChange={this.changeDecisao}
                                onFocus={this.atualizarActiveElement}
                                onLoseFocus={this.removerActiveElement}
                                salvar={this.certidaoService.salvarDecisao.bind(this, this.registro)}
                                spellCheck={true}
                                style={{ width: '100%' }}
                                tempoTimeout={4000}
                                usarBloqueio={true}
                                value={this.decisao}
                            />
                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={this.salaSessaoStore.painelPartesCertidaoExpandido}
                    onChange={this.handleChangePainelPartes}
                    style={{ margin: '0px' }}
                    sx={{ expanded: { height: '100%' } }}
                >
                    <AccordionSummary
                        expandIcon={this.getExpandIcon()}
                        style={{ minHeight: '24px' }}
                        sx={this.accordionSummaryStyle}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexGrow: 1
                            }}
                        >
                            <Typography
                                color="primary"
                                style={{ fontSize: '0.9rem', fontWeight: 'bold' }}
                                variant="subtitle2"
                            >
                                Partes
                            </Typography>
                            <Tooltip
                                placement="top"
                                title={'Expandir Partes'}
                            >
                                <AspectRatio
                                    style={{
                                        marginRight: '8px',
                                        cursor: 'pointer',
                                        width: '20px',
                                        height: '20px',
                                        color: blue[900],
                                        fillOpacity: '0.7'
                                    }}
                                    onClick={this.handleExpandirPartes}
                                />
                            </Tooltip>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails style={{ display: 'flex', flexGrow: 1, padding: '4px' }}>
                        <TextFieldSecretaria
                            inputProps={{
                                disabled: this.bloquearEdicaoCertidao,
                                style: {
                                    height: this.salaSessaoStore.painelPartesCertidaoExpandido
                                        ? this.alturaCamposCertidao
                                        : '0px'
                                }
                            }}
                            bloqueio={this.confirmaDesbloqueio}
                            callbackDesbloqueio={this.desbloquearAssinatura}
                            disabled={this.bloquearEdicaoCertidao ? true : false}
                            inputRef={this.refCampoPartes}
                            margin="none"
                            onChange={this.changePartes}
                            onFocus={this.atualizarActiveElement}
                            onLoseFocus={this.removerActiveElement}
                            salvar={this.certidaoService.salvarPartes.bind(this, this.registro)}
                            spellCheck={true}
                            style={{ width: '100%' }}
                            tempoTimeout={4000}
                            usarBloqueio={true}
                            value={this.partes ? this.partes.trim() : ''}
                        />
                    </AccordionDetails>
                </Accordion>
            </div>
        );
    }

    get accordionSummaryStyle() {
        return {
            '& .MuiAccordionSummary-root': {
                '&.Mui-expanded fieldset': {
                    margin: '0px !important'
                }
            },
            '& .MuiAccordionSummary-content': {
                margin: '0px'
            },
            '& .MuiAccordionSummary-content.Mui-expanded': {
                margin: '0px'
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
                marginRight: '0px',
                padding: '0px'
            }
        };
    }

    getExpandIcon() {
        return <ExpandMore style={{ fill: blue[900], fillOpacity: '0.6' }} />;
    }

    get renderPainelTiposJulgamento() {
        return (
            <div
                style={{
                    boxSizing: 'border-box',
                    margin: '4px 0px 4px 8px',
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    borderRadius: '4px'
                }}
            >
                <RadioGroup
                    name="tipoVotacao"
                    style={{ paddingLeft: '10px' }}
                    value={this.tipoJulgamento}
                >
                    {this.dominioStore.tiposJulgamento.map(
                        (tipoJulgamento) =>
                            this.tipoJulgamento === tipoJulgamento.constante && (
                                <FormControlLabel
                                    control={
                                        <Radio
                                            disabled
                                            style={{ padding: '6px' }}
                                        />
                                    }
                                    key={this.nextKey}
                                    label={tipoJulgamento.descricao}
                                    style={{ marginRight: '8px', paddingTop: '2px' }}
                                    value={tipoJulgamento.constante}
                                />
                            )
                    )}
                </RadioGroup>
            </div>
        );
    }

    get renderFerramentasCertidao() {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    margin: '8px',
                    width: '100%',
                    flexGrow: '1',
                    flexWrap: 'wrap',
                    alignItems: 'center'
                }}
            >
                <ProcuradorCertidao
                    assinada={this.certidaoAssinada}
                    callbackAlterarProcurador={this.callbackAlterarProcurador}
                    registro={this.registro}
                />
                <Tooltip
                    placement="top"
                    title={<Typography>{this.getTooltipBotaoRestaurarCertidao()}</Typography>}
                >
                    <span>
                        <Button
                            color="primary"
                            disabled={this.bloquearRestaurarCertidao}
                            onClick={this.handleConfirmarRestaurarCertidao}
                            size="small"
                            style={{ height: '32px' }}
                            variant={'outlined'}
                        >
                            Restaurar certidão padrão
                        </Button>
                    </span>
                </Tooltip>
                {this.renderConfirmacao()}
                <Tooltip
                    placement="top"
                    title={<Typography>{this.getTooltipBotaoAssinar()}</Typography>}
                >
                    <div style={{ display: 'flex' }}>
                        <Button
                            color="primary"
                            disabled={this.botaoAssinarDesabilitado()}
                            onClick={this.handleAssinar}
                            size="small"
                            style={{ minWidth: '150px', height: '32px' }}
                            variant={'outlined'}
                        >
                            {this.processandoAssinatura ? (
                                <CircularProgress
                                    size={14}
                                    style={{ marginRight: '8px' }}
                                />
                            ) : null}
                            {this.getRotuloBotaoAssinar()}
                            {this.certidaoAssinada ? (
                                <FontAwesomeIcon
                                    icon={faFileSignature}
                                    style={{ color: 'green', paddingLeft: '10px', fontSize: 'larger' }}
                                />
                            ) : null}
                        </Button>
                    </div>
                </Tooltip>
                <ModoAssinatura
                    callbackCancelar={this.callbackCancelar}
                    callbackContinuarAssinaturaOtp={this.callbackContinuarAssinaturaOtp}
                    modalChaveOtpOpen={this.modalChaveOtpOpen}
                    registro={this.registro}
                />
                <div style={{ height: '32px' }}>
                    Certidão em Branco
                    {this.bloquearEdicaoCertidao ? (
                        <Checkbox
                            disabled
                            checked={this.certidaoSemModelo}
                            onChange={this.handleChangeCertidao}
                            style={{ padding: '4px' }}
                        />
                    ) : (
                        <Checkbox
                            checked={this.certidaoSemModelo}
                            onChange={this.handleChangeCertidao}
                            style={{ padding: '4px' }}
                        />
                    )}
                </div>
            </div>
        );
    }

    renderConfirmacao() {
        return (
            <ModalConfirmacao
                callbackCancelar={this.fecharConfirmacaoRestaurarCertidao}
                callbackConfirmar={this.handleCarregarCertidaoPadrao}
                open={this.abrirConfirmacaoRestaurarCertidao}
                titulo={'Restaurar certidão'}
            >
                <Typography display={'inline'}>
                    {'Deseja aplicar o modelo ' +
                        (this.certidaoSemModelo ? 'EM BRANCO' : 'PADRÃO') +
                        ' ao texto editado?'}{' '}
                </Typography>
                <Typography style={{ display: 'flex', alignContent: 'center', alignItems: 'center', marginTop: '5px' }}>
                    <Warning style={{ fill: 'darkorange', marginRight: '5px' }} />
                    Atenção: Todas as alterações serão perdidas, inclusive a assinatura.
                </Typography>
            </ModalConfirmacao>
        );
    }

    get estiloAbas() {
        return {
            bgcolor: 'background.paper',
            minHeight: '36px',
            minWidth: '140px'
        };
    }

    get renderAlertaInconsistenciaEmentaDecisao() {
        if (![1, 2].includes(this.tabAtiva)) {
            return null;
        }

        const texto = this.tabAtiva === 1 ? TIPO_TEXTO.DECISAO : TIPO_TEXTO.EMENTA;

        return (
            <AlertaInconsistenciaEmentaDecisao
                registro={this.registro}
                tipoTexto={texto}
            />
        );
    }

    get renderRascunhoEmentaDecisaoAnotacoes() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-evenly',
                    marginTop: '4px',
                    marginBottom: '4px'
                }}
            >
                <AppBar position="static">
                    <Tabs
                        centered={true}
                        indicatorColor="primary"
                        sx={this.estiloAbas}
                        textColor="primary"
                        value={this.tabAtiva}
                        variant="fullWidth"
                    >
                        <Tab
                            label="Rascunho"
                            onClick={this.handleTab.bind(this, 0)}
                            sx={this.estiloAbas}
                        />
                        <Tab
                            label="Decisão"
                            onClick={this.handleTab.bind(this, 1)}
                            sx={this.estiloAbas}
                        />
                        <Tab
                            label="Ementa"
                            onClick={this.handleTab.bind(this, 2)}
                            sx={this.estiloAbas}
                        />
                        <Tab
                            label="Anotações"
                            onClick={this.handleTab.bind(this, 3)}
                            sx={this.estiloAbas}
                        />
                    </Tabs>
                </AppBar>
                <Paper
                    className="lista"
                    style={{ display: 'flex', margin: '0px', flexDirection: 'row' }}
                >
                    <TextField
                        slotProps={{
                            input: {
                                readOnly: true,
                                style: { padding: '10px' }
                            },

                            inputLabel: {
                                shrink: true
                            }
                        }}
                        fullWidth={true}
                        label={this.labelTextArea}
                        margin="dense"
                        multiline={true}
                        rows={this.appStore.larguraJanela > 1505 ? '4' : '3'}
                        value={this.conteudoTextArea}
                        variant="outlined"
                    />
                    {this.renderAlertaInconsistenciaEmentaDecisao}
                </Paper>
            </div>
        );
    }
}

export default inject('stores')(observer(Certidao));
